import React from 'react';
import { PiDotsSixVerticalBold } from 'react-icons/pi';
import { useDragContext } from './DragContext';

interface DragHandleProps {
  className?: string;
}

const DragHandle: React.FC<DragHandleProps> = ({ className = '' }) => {
  const { listeners } = useDragContext();

  return (
    <div 
      className={`flex items-center justify-center cursor-grab active:cursor-grabbing ${className}`}
      {...listeners}
      aria-label="Arrastrar fila"
    >
      <PiDotsSixVerticalBold 
        className="text-gray-900 hover:text-gray-500 transition-colors fw-bolder" 
        size={22} 
      />
    </div>
  );
};

export default DragHandle;